/**
 * Normalizacja URL-i stron podawanych przez użytkownika (VP-130).
 *
 * Użytkownicy często podają samą domenę zamiast pełnego adresu — dopisujemy
 * `https://`, żeby scrape i walidacja `z.string().url()` akceptowały takie
 * wejście. Jawnie podany schemat (http://, https://, inne) zostaje nietknięty.
 */

const URL_SCHEME_RE = /^[a-z][a-z0-9+.-]*:\/\//i;

export function normalizeWebsiteUrl(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return "";
  if (URL_SCHEME_RE.test(trimmed)) return trimmed;
  // Protocol-relative ("//cdn.example.com") — dopisz sam schemat.
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  return `https://${trimmed}`;
}
